import { SxProps, Theme } from "@mui/material";

const getStyles = (theme: Theme): Record<string, SxProps<Theme>> => ({
  title: {
    mb: "calc(2 * var(--rhythm))",
    [theme.breakpoints.down("md")]: {
      mb: "var(--rhythm)",
    },
  },

  card: {
    p: "calc(2 * var(--rhythm))",
    [theme.breakpoints.down("md")]: {
      p: "var(--rhythm)",
    },
  },
});

export default getStyles;
